<template>
  <ion-card  class="center order-items" >
    <ion-card-content>
      <i v-if="order.status===-1 || order.status === -2" class="del-btn far fa-trash-alt text-danger" @click="removeItem(index)"></i>
      <div class="order_item_div">
        <span class="input_label">عنوان :</span>
        <span>
                    {{ orderItem.product_title }}
                    <div v-if="orderItem.attr_str">({{ orderItem.attr_str }})</div>
                  </span>
      </div>
      <div class="order_item_div">
        <div class="input_label">تعداد :</div>
        <div :class="((order.status === -1 || order.status === -2)?'position-relative':'not-edit')">
          <input type="tel" v-if="order.status === -1 || order.status === -2"  v-model="small_quantity"  class="form-control quantity-input"
                 name="quantity">
          <money v-else :number="orderItem.real_quantity"></money>
          <div v-if="orderItem.have_big_unit" class="unit-title">عدد</div>
        </div>
        <div :class="((order.status === -1 || order.status === -2)?'position-relative':'not-edit')" v-if="orderItem.have_big_unit">
          <input type="tel" v-if="order.status === -1 || order.status === -2"  v-model="big_quantity"  class="form-control quantity-input"
                 name="quantity">
          <money v-else :number="big_quantity"></money>
          <div class="unit-title">{{orderItem.bigger_unit_title}}</div>
        </div>
      </div>
      <div class="order_item_div">
        <div class="input_label">مبلغ واحد :</div>
        <div>
          <Money :number="orderItem.price" ></Money> تومان
        </div>
      </div>
      <div class="order_item_div">
        <div></div>
        <div>
          جمع :
          <Money :number="orderItem.total" ></Money> تومان
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</template>

<script>
import Money from "./Money";
import {
  IonCardContent,
  IonCard
} from '@ionic/vue';
export default {
  name: "orderItemEdit",
  methods:{
    calculateItemBiggerUnit(unit)
    {
      const orderItem = this.orderItem;
      if (orderItem.bigger_unit)
      {
        const bigger_unit_quantity = orderItem.bigger_unit_quantity;
        let selected_qty = Number(orderItem.selected_qty);
        if (unit === 'small')
        {
          if (!isNaN(selected_qty))
          {
            orderItem.big_qty = Math.round((selected_qty / bigger_unit_quantity)*100)/100;
          }
        }
        else if (unit === 'big')
        {
          if (orderItem.big_qty && !isNaN(orderItem.big_qty))
          {
            orderItem.selected_qty = Math.round((orderItem.big_qty * bigger_unit_quantity));
          }
        }
      }
    },
    removeItem()
    {
      this.del_item = new Date().getTime();
    },
    changeSmallUnit()
    {
      const self = this;
      const currentChange = self.currentChange;
      if (currentChange === 'small' || !currentChange)
      {
        this.currentChange = 'small';
        if (self.orderItem.have_big_unit)
        {
          let bigger_unit_quantity = this.orderItem.bigger_unit_quantity;
          let val = this.small_quantity;
          val = Number(val);
          if (!isNaN(val))
          {
            self.big_quantity = Number((val / bigger_unit_quantity).toFixed(2));
            self.orderItem.real_quantity = Number(val);
          }
        }
        else if (!isNaN(this.small_quantity))
        {
          self.orderItem.real_quantity = Number(this.small_quantity);
        }
        setTimeout(function (){
          self.currentChange = null;
        },600);
      }
    },
    changeBigUnit()
    {
      const self = this;
      const currentChange = self.currentChange;
      if (currentChange === 'big' || !currentChange)
      {
        self.currentChange = 'big';
        const bigger_unit_quantity = this.orderItem.bigger_unit_quantity;
        let val = this.big_quantity;
        val = Number(val);
        if (!isNaN(val))
        {
          self.small_quantity = Number((val * bigger_unit_quantity).toFixed(0));
          self.orderItem.real_quantity = self.small_quantity;
        }

        setTimeout(function (){
          self.currentChange = null;
        },600);
      }
    }
  },
  components:{
    Money,IonCardContent,IonCard
  },
  data:function ()
  {
    return {
      currentChange : null,
      orderItem:'',
      small_quantity: 0,
      big_quantity: 0,
      big_change : false,
      small_change : false,
      del_item:''
    }
  },
  watch:{
    small_quantity : {
      handler()
      {
        this.changeSmallUnit();
      }
    },
    big_quantity : {
      handler()
      {
        this.changeBigUnit();
      }
    },
    "orderItem" :{
      handler(orderItem)
      {
        this.$emit('itemChanged',orderItem)
      },deep: true,
    },
    del_item:{
      handler: function ()
      {
        this.$emit('del_items')
      },
      deep: true
    }
  },
  mounted()
  {
    const item = JSON.parse(JSON.stringify(this.item));
    this.small_quantity = item.real_quantity;
    if (item.have_big_unit)
    {
      this.big_quantity = Number((item.real_quantity / item.bigger_unit_quantity).toFixed(2));
    }
    this.orderItem = item;
  },

  props:['order','item','index']
}
</script>

<style scoped>
.quantity-input {
  width: 50px;
}
.del-btn {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 20px;
  padding: 6px;
  cursor: pointer;
}
.order_item_div
{
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-bottom: 9px;
  align-self: center;
}
.order_item_div > div
{
  align-self: center;
}
.del-btn
{
  background: transparent;
}
.order-items
{
  background: #CFD8DC;
  color: #222222;
}
.order-items
{
  background: #CFD8DC;
  color: #222222;
  margin: 5px !important;
  min-width: 270px;
}
.order_item_div > span
{
  white-space: break-spaces;
}
.input_label{
  width: 85px;
  text-align: right;
}
.unit-title
{
  position: absolute;
  top: -10px;
  font-size: 13px;
  color: #dc3545 !important;
  right: auto;
  /* left: 0; */
}
.position-relative
{
  position: relative;
}
.not-edit .unit-title
{
  margin-top: 5px;
  position: relative!important;
}
</style>